import * as ko from 'knockout';

import * as regionsApi from '../api/regions';
import { I18nText } from '../i18n_text';
import { CountryData } from '../api/countries';
import { getCountrySearchConfig } from '../components/configs/search_configs';
import { SlugGenerator } from '../ko_bindings/slug_validation';

export class Region {
  private slugGenerator: SlugGenerator;

  id = ko.observable<string>(null);
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });
  country = ko.observable<CountryData>(null);
  code = ko.observable('').extend({
    required: true,
    serverError: true,
  });

  countrySearchConfig = getCountrySearchConfig(this.country);

  editUrl = ko.pureComputed(() => {
    return '/regions/' + this.id() + '/';
  });

  constructor(data?: regionsApi.RegionData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
      this.country(data.country);
      this.code(data.code);
    }

    this.slugGenerator = new SlugGenerator(this.nameJson, null, this.code, {
      canEdit: !this.id(),
      fillIfEmpty: true,
    });
  }

  toData(): regionsApi.RegionData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
      country: this.country(),
      code: this.code(),
    };
  }

  dispose() {
    this.slugGenerator.dispose();
  }
}
